import { render, staticRenderFns } from "./FModalHeader.vue?vue&type=template&id=51d4f6a7&"
import script from "./FModalHeader.vue?vue&type=script&lang=js&"
export * from "./FModalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports